import $ from 'jquery';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');

$(function () {
    $('.accordion-with-image[data-awi]').each(function () {

        if (inBackend) return;

        const $root = $(this);
        const $img = $root.find('[data-awi-image]').first();
        const $items = $root.find('[data-awi-item]');

        // initial active: first item (falls Bild vorhanden)
        const $first = $items.first();
        if ($first.length) {
            $items.removeClass('is-active');
            $first.addClass('is-active');

            const initialUrl = $first.data('image');
            if (initialUrl) {
                $img.attr('src', initialUrl);
            }
        }

        $items.each(function () {
            const $item = $(this);
            const $trigger = $item.find('[data-awi-trigger]').first();

            $trigger.on('click', function () {
                const url = $item.data('image');
                if (url) $img.attr('src', url);

                $items.removeClass('is-active');
                $item.addClass('is-active');

                // Optional: Panel-Logik (wenn du "Accordion" Verhalten willst)
                // - alle schließen, eins öffnen:
                $items.find('.accordion-with-image__panel').slideUp(150);
                $item.find('.accordion-with-image__panel').slideDown(150);
            });
        });

        // Optional: beim Start Panels definieren (nur active offen)
        $items.find('.accordion-with-image__panel').hide();
        $root.find('.accordion-with-image__item.is-active .accordion-with-image__panel').show();
    });
});
